import { Entity, generateEntityId } from './entity';
import type { Vector2 } from '../core/constants';

export class NapalmDroplet implements Entity {
  id: string;
  position: Vector2;
  velocity: Vector2;
  active = true;

  private windEffect: number;

  onLand?: (x: number, y: number) => void;

  constructor(x: number, y: number, wind: number) {
    this.id = generateEntityId('napalm_drop');
    this.position = { x, y };
    this.velocity = { x: wind * 0.3, y: 0 };
    this.windEffect = wind * 0.02;
  }

  update(deltaTime: number): void {
    if (!this.active) return;

    this.velocity.y += 600 * deltaTime;
    this.velocity.x += this.windEffect;

    this.position.x += this.velocity.x * deltaTime;
    this.position.y += this.velocity.y * deltaTime;
  }

  checkTerrainCollision(terrain: { isSolid(x: number, y: number): boolean }): boolean {
    return terrain.isSolid(this.position.x, this.position.y);
  }

  checkWaterCollision(waterLevel: number, worldHeight: number): boolean {
    const waterY = worldHeight - waterLevel;
    return this.position.y > waterY;
  }

  land(): void {
    if (!this.active) return;
    this.active = false;
    this.onLand?.(this.position.x, this.position.y);
  }

  destroy(): void {
    this.active = false;
  }
}
